/**
 * Pauses autoplaying background videos inside video-review-card when
 * the user prefers reduced motion. Safe to include multiple times.
 */
(() => {
  if (window.__videoReviewCardReducedMotionInit) return;
  window.__videoReviewCardReducedMotionInit = true;

  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
  const MEDIA_SELECTOR = '.video-review-card video.video-review-card__media';

  /**
   * @param {boolean} reduced
   */
  const syncVideos = (reduced) => {
    const videos = document.querySelectorAll(MEDIA_SELECTOR);

    for (const video of videos) {
      if (reduced) {
        video.pause();
        video.removeAttribute('autoplay');
      } else if (video.paused) {
        video.setAttribute('autoplay', '');
        video.play()?.catch(() => {});
      }
    }
  };

  const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);

  const onChange = () => {
    syncVideos(mediaQuery.matches);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onChange, { once: true });
  } else {
    onChange();
  }

  if (typeof mediaQuery.addEventListener === 'function') {
    mediaQuery.addEventListener('change', onChange);
  } else {
    mediaQuery.addListener(onChange);
  }
})();
